/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 1000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Simon Renuart",
  title: "Hi all, I'm Simon",
  subTitle: emoji(
    "I am a highly motivated and autonomous AI Software Engineer with a strong focus on client satisfaction. My background in applied sciences enables me to tackle a wide range of complex problems creatively. I thrive on staying updated with the latest innovations and technologies, seeking challenging projects that push my boundaries. As a genuine team player, I am passionate about continuous learning and fostering collaboration through effective communication and knowledge sharing with my colleagues."
  ),
  resumeLink:
    "", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  linkedin: "https://www.linkedin.com/in/simonrenuart/",
  github: "https://github.com/sire6",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "AI Software Engineer who wants to explore the tech at all levels",
  skills: [
    emoji("⚡ Design and implement scalable and efficient AI solutions for real-world applications"),
    emoji("⚡ Develop and deploy AI pipelines with efficiency and quality in mind."),
    emoji("⚡ Establish processes to evaluate and compare models based on client datasets"),
    emoji("⚡ AI pipeline throughput optimization and performance tuning"),
    emoji("⚡ Design and implement scalable and efficient AI solutions for real-world applications"),
    emoji("⚡ Manage data pipelines, whether by preparing and transforming data for processing or by post-processing the output to extract maximum value.") 
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Docker",
      reactIcon: "SiDocker"
    },
    {
      skillName: "Deepstream",
      reactIcon: "SiNvidia"
    },
    {
      skillName: "TAO Toolkit",
      reactIcon: "SiNvidia"
    },
    {
      skillName: "Model Analyzer",
      reactIcon: "SiNvidia"
    },
    {
      skillName: "Triton gRPC",
      reactIcon: "SiNvidia"
    },
    {
      skillName: "Jetson",
      reactIcon: "SiNvidia"
    },
    {
      skillName: "TensorRT",
      reactIcon: "SiNvidia"
    },
    {
      skillName: "Tensorflow",
      reactIcon: "SiTensorflow"
    },
    {
      skillName: "PyTorch",
      reactIcon: "SiPytorch"
    },
    {
      skillName: "Darknet",
      reactIcon: "FaEye"
    },
    {
      skillName: "FFMPEG",
      reactIcon: "SiFfmpeg"
    },
    {
      skillName: "Apache Kafka",
      reactIcon: "SiApachekafka"
    },
    {
      skillName: "Apache Flink",
      reactIcon: "SiApacheflink"
    },
    {
      skillName: "IP cameras",
      reactIcon: "FaVideo"
    },
    {
      skillName: "Sensors",
      reactIcon: "FaThermometerHalf"
    },
    {
      skillName: "BIOS / UBOOT",
      reactIcon: "FaMicrochip"
    },
    {
      skillName: "Self-hosted tools",
      reactIcon: "FaTools"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "UMONS Faculty of Engineering (FPMS)",
      logo: require("./assets/images/polytechLogo.png"),
      subHeader: "Master's Degree in Computer Engineering and Management",
      duration: "2019 - 2021",
      desc: "Specialization in Artificial Intelligence and Decision Aid",
    },
    {
      schoolName: "UMONS Faculty of Engineering (FPMS)",
      logo: require("./assets/images/polytechLogo.png"),
      subHeader: "Bachelor's Degree in Applied Sciences Engineering",
      duration: "2015 - 2019",
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: false, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Computer Vision Software Engineer",
      company: "TRU Recognition, Melbourne AUS",
      companylogo: require("./assets/images/truLogo.png"),
      date: "Nov 2023 – Present",
      desc: "",
      descBullets: [

      ]
    },
    {
      role: "Computer Vision Software Engineer",
      company: "Phoenix AI, Peruwelz BE",
      companylogo: require("./assets/images/phoenixaiLogo.png"),
      date: "Sep 2021  – Jan 2023",
      desc: ""
    },
    {
      role: "Computer Vision Software Engineer - Internship",
      company: "Infrabel, Brussels BE",
      companylogo: require("./assets/images/infrabelLogo.png"),
      date: "Jul 2020 – Sep 2020",
      desc: ""
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Want my resume or just want to say hi?"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
